import React from 'react';
import envConfig from '@nile/home/src/Config/env';
import { BackgroundIcon } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

export const constructDataForSelection = (data, id = 'id') => {
  return data
    ? data.map((el) => {
        return {
          ...el,
          id: el[id],
          name: el.name,
          label: el.name
        };
      })
    : [];
};

export function ClientFallback(props) {
  return (
    <div className="fx center" style={{ opacity: 0.4 }}>
      <SVGIcon name="ClientLogo" size="lg" />
    </div>
  );
}
